import { Box } from "@mui/material"
import ReactGA from "react-ga4"

interface AdvertisementProps {
  imageUrl: string
  hrefLink: string
  aspectRatio: "tall" | "short" | "square"
  additionalStyling?: object
  companyName: string
  advertisementId: number
}

// const aspectRatioStyles = {
//   short: {
//     aspectRatio: "16 / 9",
//   },
//   tall: {
//     aspectRatio: "9 / 16",
//   },
//   square: {
//     aspectRatio: "1 / 1",
//   },
// }

const Advertisement = ({
  imageUrl,
  hrefLink,
  aspectRatio,
  additionalStyling,
  companyName,
  advertisementId,
}: AdvertisementProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        overflow: "hidden",
        ...additionalStyling,
      }}
    >
      <a
        href={hrefLink}
        onClick={() => {
          ReactGA.event({
            category: "Event",
            action: "Click advertisement url",
            label: companyName,
            value: advertisementId,
          })
        }}
        target="_blank"
        style={{
          display: "block",
          width: "100%",
          height: "100%",
          // maxWidth: "20rem",
          position: "relative",
        }}
      >
        <Box
          component="img"
          src={imageUrl}
          alt="Advertisement"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            aspectRatio: aspectRatio,
          }}
        />
      </a>
    </Box>
  )
}

export default Advertisement
